<script setup>
import { ref, onBeforeMount, computed } from "vue";
import { useCompanyStore } from "@/stores/company";
import { useUiStore } from "@/stores/ui";
import { useDevicesStore } from "@/stores/devices";

const props = defineProps({
  configsOptions: Array,
  agentsOptions: Array,
});

const emit = defineEmits(["refresh"]);
const uiStore = useUiStore();
const devicesStore = useDevicesStore();

const company_id = useCompanyStore().companyId;
const getModalInfo = computed(() => uiStore.modalData);
const getModalAction = computed(() => uiStore.modalAction);

let id = ref(null);
let name = ref(null);
let config = ref(null);
let agent = ref(null);
let isSubmitted = ref(false);

const onSubmit = () => {
  isSubmitted.value = true;
  const data = {
    id: id.value,
    name: name.value,
    config_id: config.value,
    agent_id: agent.value,
    company_id,
  };

  devicesStore
    .editDevice(data)
    .then(() => {
      emit("refresh");
      resetStoreData();
      isSubmitted.value = false;
    })
    .catch(() => {
      isSubmitted.value = false;
    });
};

const resetStoreData = () => {
  uiStore.setModalState(false);
  uiStore.setModalData({});
  uiStore.setModalAction(null);
};

onBeforeMount(() => {
  if (
    getModalInfo.value &&
    getModalInfo.value.data_type == "device" &&
    getModalAction.value == "edit_device"
  ) {
    id.value = getModalInfo.value.id;
    name.value = getModalInfo.value.name;
    config.value = getModalInfo.value.configuration?.id;
    agent.value = getModalInfo.value.agent?.id;
  }
});
</script>

<template>
  <DModal v-if="getModalAction === 'edit_device'" :visible="uiStore.modalState" @update:visible="val => { if (!val) resetStoreData() }" :main_classes="[]" :dialog_classes="[]">
    <template #title> Edit Kiosk </template>
    <template #body>
      <DInput :value="name" @input="name = $event.target.value" label="Device Name" width="100%" />

      <!-- <div class="relative mb-3">
        <span v-if="config" class="multiselect-title-span">Configuration</span>
        <VMultiselect
          v-model="config"
          :options="props.configsOptions"
          trackBy="id"
          label="name"
          :searchable="true"
          :close-on-select="true"
          :show-labels="false"
          placeholder="Configuration"
        />
      </div> -->

      <FloatLabel class="w-full md:w-14rem mb-3">
        <PDropdown
          v-model="config"
          inputId="config"
          :options="props.configsOptions"
          optionLabel="name"
          optionValue="id"
          class="w-full"
          filter
          filterPlaceholder="Search by configuration name"
        />
        <label for="config">Configuration</label>
      </FloatLabel>

      <!-- <div class="relative">
        <span v-if="agent" class="multiselect-title-span">Agent</span>
        <VMultiselect
          v-model="agent"
          :options="props.agentsOptions"
          trackBy="id"
          label="name"
          :searchable="true"
          :close-on-select="true"
          :show-labels="false"
          placeholder="Agent"
        />
      </div> -->

      <FloatLabel class="w-full md:w-14rem mb-3">
        <PDropdown
          v-model="agent"
          inputId="agent"
          :options="props.agentsOptions"
          optionLabel="name"
          optionValue="id"
          class="w-full"
          filter
          filterPlaceholder="Search by agent name"
        />
        <label for="agent">Agent</label>
      </FloatLabel>
    </template>

    <template #footer>
      <div class="w-full">
        <div class="seperator text-center"></div>
        <div class="flex mt-20 justify-center">
          <button
            :disabled="!name || !config || isSubmitted"
            @click="onSubmit"
            type="button"
            class="btn btn-primary add-button mr-30"
          >
            Edit
            <span
              v-if="isSubmitted"
              class="spinner-sm"
              role="status"
              aria-hidden="true"
            ></span>
          </button>
          <button
            @click="resetStoreData"
            type="button"
            class="btn btn-secondary cancel-button"
          >
            Cancel
          </button>
        </div>
      </div>
    </template>
  </DModal>
</template>
